import { z } from 'zod';
import { WithId } from './WithId';

export const ClinicCreateSchema = z.object({
  name: z.string(),
  address: z.string().nullable().optional(),
  email: z.string().email().nullable().optional(),
  phone: z.string().nullable().optional(),
});

export type ClinicCreate = z.infer<typeof ClinicCreateSchema>;

export const ClinicUpdateSchema = z.object({
  name: z.string().nullable().optional(),
  address: z.string().nullable().optional(),
  email: z.string().email().nullable().optional(),
  phone: z.string().nullable().optional(),
});

export type ClinicUpdate = z.infer<typeof ClinicUpdateSchema>;

export type ClinicResponse = WithId & {
  name?: string | null;
  address?: string | null;
  email?: string | null;
  phone?: string | null;
};
